<template>
    <span>
        <a href="javascript:void(1);" @click="load" v-b-tooltip.hover title="Ver Histórico" :class="{'text-primary link-underline-light': modeButton}">
            <svg height="16px" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
                <path stroke-linecap="round" stroke-linejoin="round" d="M8.25 6.75h12M8.25 12h12m-12 5.25h12M3.75 6.75h.007v.008H3.75V6.75zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zM3.75 12h.007v.008H3.75V12zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0zm-.375 5.25h.007v.008H3.75v-.008zm.375 0a.375.375 0 11-.75 0 .375.375 0 01.75 0z" />
              </svg>
            <slot></slot>
            <span v-if="modeButton" class="ml-1">
                Histórico do Aluno
            </span>
        </a>

        <b-modal
            :id="modalId"
            title="Últimas Redações"
            centered
            size="xl"
            hide-footer>
            <b-overlay :show="loading" rounded="sm">
                <table class="table table-bordered">
                    <thead>
                        <tr>
                            <th>
                                Corretor
                            </th>
                            <th>
                                Modo de Correção
                            </th>
                            <th>
                                Nota
                            </th>
                            <th>
                                Enviada
                            </th>
                            <th>
                                Corrigida
                            </th>
                            <th>
                                Status
                            </th>
                            <th>
                                Ações
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="lastEssays.lenght === 0">
                            <td colspan="3">
                                Não há histórico de redações :(
                            </td>
                        </tr>
                        <tr v-for="essay in lastEssays" :key="essay.id">
                            <td>
                                <span v-if="essay.teacher">
                                    {{ essay.teacher.name }}
                                </span>
                                <span v-else>
                                    ---
                                </span>
                            </td>
                            <td>
                                <span v-if="essay.mode">
                                    <span v-b-tooltip.hover :title="essay.mode.name">
                                        {{ essay.mode.name | truncate(25) }}
                                    </span>
                                </span>
                                <span v-else>
                                    <span v-if="essay.theme">
                                        <span v-b-tooltip.hover :title="essay.theme.mode.name">
                                            {{ essay.theme.mode.name | truncate(25) }}
                                        </span>
                                    </span>
                                    <span v-else>
                                        ---
                                    </span>
                                </span>
                            </td>
                            <td>
                                <span v-if="essay.status === 'OKAY'">
                                    <span v-if="!essay.no_note">
                                        {{ essay.note }}
                                    </span>
                                    <span class="px-2 py-1 rounded-pill text-nowrap" style="background-color: #ffc10720; color: #ffc107;" v-else>
                                        Sem nota
                                    </span>
                                </span>
                                <span v-else>
                                    ---
                                </span>
                            </td>
                            <td>
                                <span v-b-tooltip.hover :title="essay.created_at | moment('from', 'now')">
                                    {{ essay.created_at | moment('DD/MM/YYYY HH:mm') }}
                                </span>
                            </td>
                            <td>
                                <span v-if="essay.finished_correction">
                                    <span v-b-tooltip.hover :title="essay.finished_correction | moment('from', 'now')">
                                        {{ essay.finished_correction | moment('DD/MM/YYYY HH:mm') }}
                                    </span>
                                </span>
                                <span v-else>
                                    ---
                                </span>
                            </td>
                            <td>
                                <span v-if="essay.status === 'WAIT'" class="text-danger bg-danger-subtle">
                                    Aguardando
                                </span>

                                <span v-if="essay.status === 'IN_PROGRESS'" class="text-info">
                                    Em Andamento
                                </span>

                                <span v-if="essay.status === 'OKAY'" class="text-success">
                                    Corrigida
                                </span>
                            </td>
                            <td class="text-center">
                                <a :href="'/teacher/essays/' + essay.id + '/correction'" class="" v-b-tooltip.hover title="Visualizar Correção" :disabled="loading" target="_blank">
                                    <i class="fas fa-arrow-right"></i>
                                </a>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </b-overlay>
        </b-modal>
    </span>
</template>

<script>
import Table from './reports-teachers/Table.vue';
export default {
  components: { Table },
    props: ['studentId', 'modalId', 'modeButton'],
    data() {
        return {
            loading: false,
            lastEssays: [],
        }
    },
    created() {

    },
    methods: {

        load() {
            this.$bvModal.show(this.modalId)
            this.loading = true;
            axios.get('/teacher/students/' + this.studentId + '/last-essays')
                .then((result) => {
                    const response = result.data.data
                    this.lastEssays = response.lastEssays
                })
                .finally(() => this.loading = false)
        },

    }
}
</script>

<style scoped>

</style>
